import Vue from 'vue';
import Vuex from 'vuex';

import audio from './modules/audio';
import auth from './modules/auth';
import cards from './modules/cards';
import dailyCards from './modules/dailyCards';
import device from './modules/device';
import favorites from './modules/favorites';
import posts from './modules/posts';
import purchases from './modules/purchases';
import stacks from './modules/stacks';
import strings from './modules/strings';
import ui from './modules/ui';
import user from './modules/user';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    audio,
    auth,
    cards,
    dailyCards,
    device,
    favorites,
    posts,
    purchases,
    stacks,
    strings,
    ui,
    user,
  },
  strict: process.env.NODE_ENV !== 'production',
});

// Init basic info
store.dispatch('device/init');
store.dispatch('auth/init');
store.dispatch('strings/init');
store.dispatch('ui/init');

// Init flow for modules that need userID & subscriber status
// auth -> user ->
//                 cards -> dailyCards
//                 stacks
//                 audio
//                 purchases

export default store;

// Template for modules:

// /*

//   STATE

//  */

// const state = {

// };

// /*

//   GETTERS

//  */

// const getters = {
//   exampleGetter: state => { },
// };

// /*

//   ACTIONS

//  */

// const actions = {
//   exampleAction({ commit, dispatch, state, getters, rootState, rootGetters }, otherParams) { },
// };

// /*

//   MUTATIONS

//  */

// const mutations = {
//   exampleMutation(state, data) {
//     state.property = data;
//   },
// };

// export default {
//   namespaced: true,
//   state,
//   getters,
//   actions,
//   mutations,
// };
